import { Loader2 } from "lucide-react";
import { cn } from "@/lib/utils";
import { ToolStatus } from "@optidev/shared-types";

interface SkillCardProps {
  /** Raw slug as stored in skillMap (before display transformation) */
  slug: string;
  status: ToolStatus;
  /** True for built-in base skills (frontend, themes, etc.), false for marketplace */
  isBaseSkill: boolean;
}

export function SkillCard({ slug, status, isBaseSkill }: SkillCardProps) {
  const isCustom = slug.startsWith("custom-");
  const displaySlug = slug.replace(/^custom-/, "");
  const isLoading = status === ToolStatus.RUNNING;
  const isFailed = status === ToolStatus.ERROR;

  return (
    <div className="text-xs leading-relaxed">
      <div className="flex items-center gap-1.5">
        <span
          className={cn(
            "w-1.5 h-1.5 rounded-full flex-shrink-0",
            isLoading && "bg-blue-400 animate-pulse",
            isFailed && "bg-amber-400",
            !isLoading &&
              !isFailed &&
              (isBaseSkill
                ? "bg-blue-400"
                : isCustom
                  ? "bg-violet-400"
                  : "bg-emerald-400"),
          )}
        />
        <span className="font-mono font-semibold text-muted-foreground">
          Skill(/{displaySlug})
        </span>
      </div>
      <div
        className={cn(
          "flex items-center gap-1 ml-3 pl-0.5",
          isFailed ? "text-amber-500/70" : "text-muted-foreground/50",
        )}
      >
        <span className="select-none text-muted-foreground/30">{"└"}</span>
        {isLoading ? (
          <>
            <Loader2 className="w-3 h-3 animate-spin flex-shrink-0" />
            <span>Loading skill…</span>
          </>
        ) : isFailed ? (
          <span>Failed to load skill</span>
        ) : (
          <span>Successfully loaded skill</span>
        )}
      </div>
    </div>
  );
}
